import { defaultState } from "@/shared/utilities/constants";

export default () => ({
  teachersResult: { ...defaultState },
});
